export default {
  "wt-popup": "_wt-popup_pdh19y_3",
  "wt-popup__overlay": "_wt-popup__overlay_pdh19y_54",
  "wt-popup__close_embedded": "_wt-popup__close_embedded_pdh19y_66",
  "wt-popup__header": "_wt-popup__header_pdh19y_74",
  "wt-popup__close_header": "_wt-popup__close_header_pdh19y_74",
  "wt-popup__content": "_wt-popup__content_pdh19y_96",
  "wt-popup__footer": "_wt-popup__footer_pdh19y_122",
  "wt-popup__loading-icon": "_wt-popup__loading-icon_pdh19y_134"
};